
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import LastSync from '@/components/LastSync.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import gdbx from '@/store/modules/gdbx';
// tslint:disable:max-line-length
import TotalAssetNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpTotalAssetsNumberDisplayer.vue';
import TotalLiabilityNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpTotalLiabilitiesNumberDisplayer.vue';
import TotalEquityNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpTotalEquityNumberDisplayer.vue';
import FinancialPositionBarAssetChart from '@/components/reports-v3/components/codedWidgets/bp/BpFinancialPositionAssetsChart.vue';
import FinancialPositionBarLiabilitiesEquitiesChart from '@/components/reports-v3/components/codedWidgets/bp/BpFinancialPositionLiabilitiesEquitiesChart.vue';

@Component({
	components: {
		StickyFilterContainer,
		DateFilter,
		LastSync,
		TotalAssetNumberDisplayer,
		TotalLiabilityNumberDisplayer,
		TotalEquityNumberDisplayer,
		FinancialPositionBarAssetChart,
		FinancialPositionBarLiabilitiesEquitiesChart,
	},
})
export default class BalanceSheet extends Vue {
	public selectedDay: number = moment().endOf('day').valueOf();
	public selectedDateRange: [number, number] = [
		moment().startOf('year').valueOf(),
		moment().endOf('day').valueOf(),
	];

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('day').valueOf();
	}

	public get selectedAgents() {
		return gdbx.allAgents;
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
